module.exports = __webpack_public_path__ + "img/icon-download.4d740692.svg";